import { component } from 'picoapp';

export default component((node) => {
  /**
   * Data + elements
   */
  const shippingDateOutput = node.querySelector('.js-shippingDate');

  const config = JSON.parse(node.dataset.config);
  const {
    dailyShippingTime,
    shippingDays,
    allowedWeekdays,
    googleCalendarAPIKey,
    googleCalendarID,
    reverseDates,
  } = config;

  const weekdayStrings = window.theme.strings.weekdays;

  /**
   * Functions
   */
  const getGoogleData = () => new Promise((resolve) => {
    window.gapi.load('client', () => {
      window.gapi.client.init({
        apiKey: googleCalendarAPIKey,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
      })
        .then(() => window.gapi.client.calendar.events.list({
          calendarId: googleCalendarID,
          singleEvents: true,
          orderBy: 'startTime',
        }))
        .then((response) => {
          resolve(response.result.items);
        })
        .catch((error) => {
          console.error(error); // eslint-disable-line
          resolve([]);
        });
    });
  });

  const setShippingDate = async () => {
    const googleData = await getGoogleData();

    const shippingDate = new Date();
    let daysAdded = 0;

    const getDatesBetween = (startDate, endDate) => {
      const dates = [];
      let currentDate = startDate;
      while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate = new Date(currentDate.valueOf());
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dates;
    };

    const testDateAgainstCalendar = () => {
      const blockingItem = googleData.find((item) => {
        const dates = getDatesBetween(new Date(item.start.dateTime), new Date(item.end.dateTime));
        return dates.find((date) => date.toDateString() === shippingDate.toDateString());
      });

      return !blockingItem;
    };

    const tryAddDay = () => {
      shippingDate.setDate(shippingDate.getDate() + 1);

      if (allowedWeekdays.includes(shippingDate.getDay()) && testDateAgainstCalendar()) {
        daysAdded += 1;
      }
    };

    if ((shippingDate.getHours() > dailyShippingTime) || (shippingDate.getHours === dailyShippingTime && shippingDate.getMinutes > 0)) { // eslint-disable-line
      tryAddDay();
    }

    while (daysAdded < shippingDays) {
      tryAddDay();
    }

    const date = shippingDate.getDate();
    const month = shippingDate.getMonth() + 1;
    const dateString = `${weekdayStrings[shippingDate.getDay()]} ${reverseDates ? month : date}/${reverseDates ? date : month}`; // eslint-disable-line

    shippingDateOutput.textContent = dateString;
  };

  const init = () => {
    if (window.gapi) {
      setShippingDate();
    } else {
      window.addEventListener('googleApi:loaded', setShippingDate);
    }
  };

  /**
   * Init
   */
  init();
});
